<template>
    <div>
        <b-card :title="$t('Page(SystemSecurityOperations):Component(Text):system-security-operations')">
            <!-- table -->
            <vue-good-table
                :columns="columns"
                :rows="rows"
                :rtl="direction"
                :search-options="{
                    enabled: true,
                    externalQuery: searchTerm
                }"
                :pagination-options="{
                    enabled: true,
                }"
                styleClass="vgt-table bordered striped"
            >
                <template
                    slot="table-row"
                    slot-scope="props"
                >
                    <!-- Column: Common -->
                    <span >
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>
                <!-- pagination -->
                <template
                    slot="pagination-bottom"
                    slot-scope="props"
                >
                    <div class="d-flex justify-content-between flex-wrap">
                        <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap">
                              Showing 1 to
                            </span>
                            <b-form-select
                                v-model="pageLength"
                                :options="['10','15','20']"
                                class="mx-1"
                                @input="(value)=>props.perPageChanged({currentPerPage:value})"
                            />
                            <span class="text-nowrap "> of {{ props.total }} entries </span>
                        </div>
                        <div>
                            <b-pagination
                                :value="1"
                                :total-rows="props.total"
                                :per-page="pageLength"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="mt-1 mb-0"
                                @input="(value)=>props.pageChanged({currentPage:value})"
                            >
                                <template #prev-text>
                                    <feather-icon
                                        icon="ChevronLeftIcon"
                                        size="18"
                                    />
                                </template>
                                <template #next-text>
                                    <feather-icon
                                        icon="ChevronRightIcon"
                                        size="18"
                                    />
                                </template>
                            </b-pagination>
                        </div>
                    </div>
                </template>
            </vue-good-table>
        </b-card>
    </div>
</template>

<script>
import {
    BForm, BFormTextarea, BCard, BModal, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import {SystemApi} from '@core/api'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    components: {
        ToastificationContent,
        BFormTextarea,
        BModal,
        BForm,
        BCard,
        VueGoodTable,
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
    },
    directives: {
        Ripple,
    },
    name: "SystemServices",
    data() {
        return {
            pageLength: 10,
            direction: false,
            operations: [],
            columns: [
                {
                    label: this.$t('Page(SystemSecurityOperations):Component(Text):name'),
                    field: 'name',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Search Name',
                    },
                },
                {
                    label: this.$t('Page(SystemSecurityOperations):Component(Text):description'),
                    field: 'description',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Search Name',
                    },
                },
            ],
            translations: [],
            selectedKey: '',
            rows: [],
            searchTerm: '',
        }
    },
    methods: {
        fetchOperations() {
            SystemApi.security.getOperations().then((r) => {
                this.rows = r.data
            });
        },
    },
    created() {
        this.fetchOperations();
    }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
